module.exports = function ($, M) {
  'use strict';
  M.Whitebox = {
    defaults: {},
    centered_box: function (options, callback) {
      var opts = $.extend({}, this.defaults, options);
      M.renderer.ready(function () {
        var context = {
            content: opts.template,
            data: opts.data,
          },
          html = M.renderer.render(opts.parent, context),
          $wb = $(html).appendTo('body');
      });
    },
  };
};
